import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#B269AE",
      light: "#FFDE66", 
    },
    secondary: {
      main: "#631958bd",
    },
    warning: {
      main: "#FFDE66",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
